import { render } from "./MemberProjects.vue?vue&type=template&id=b30f5c2c&scoped=true"
import script from "./MemberProjects.vue?vue&type=script&lang=js"
export * from "./MemberProjects.vue?vue&type=script&lang=js"

import "./MemberProjects.vue?vue&type=style&index=0&id=b30f5c2c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b30f5c2c"]])

export default __exports__